import React from 'react';
import { BannerReact } from 'common/components/banner';
import { ActionEvent, BannerAction, BannerTheme, BannerType } from 'common/components/banner/types';
import { ButtonTheme } from 'common/components/button/constants';
import { useExperimentPageContext } from 'apps/experiments/src/components/context';
import { useForceConcludeExperiment } from 'iron/apps/experiments/src/components/hooks/force-conclude-experiment';
import { useTranslation } from 'common/i18n/hooks';
export function ExperimentPageBannerRunning() {
  const {
    t
  } = useTranslation();
  const {
    canEdit
  } = useExperimentPageContext();
  const forceConcludeExperiment = useForceConcludeExperiment();
  return <BannerReact headerText={t("experiments.banner.running.title")} bodyText={t("experiments.banner.running.body")} theme={BannerTheme.Warn} type={BannerType.Embedded} ctas={canEdit ? [{
    actionName: BannerAction.Custom,
    text: "Force Complete",
    theme: ButtonTheme.Primary
  }] : []} onAction={(ev: ActionEvent) => {
    if (ev.detail.actionName === BannerAction.Custom) {
      forceConcludeExperiment();
    }
  }} data-sentry-element="BannerReact" data-sentry-component="ExperimentPageBannerRunning" data-sentry-source-file="_running.tsx" />;
}